module.exports = __webpack_public_path__ + "static/media/LocationMarkerDefault.ddd67aa1.svg";